import script from "./UnlayerEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnlayerEditor.vue?vue&type=script&setup=true&lang=ts"

import "./UnlayerEditor.vue?vue&type=style&index=0&id=51f49ed7&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f49ed7"]])

export default __exports__